// Remembers which product the user clicked to leave a page, keyed by the
// react-router history entry (location.key). On Back/Forward we scroll that
// exact card back into view — reliable even when the page's height changes as
// lazy sections/images load in.
//
// We store the product id AND the card's absolute document position at click
// time. The same product can appear in several rows (e.g. New Arrivals AND Best
// Sellers), so on return there can be multiple cards with the same id — the
// saved position lets us pick the *specific* one the user actually clicked,
// instead of always jumping to the first one in the DOM.
const anchors = new Map();

export const rememberAnchor = (key, id, top) => {
  if (key && id != null) anchors.set(key, { id: String(id), top });
};

export const getAnchor = (key) => (key ? anchors.get(key) : null);

// Drop the stored anchor for a history entry. Called when the user leaves a page
// by clicking something that ISN'T a product card (a category tile, a banner, a
// "View All" link). Otherwise a stale card anchor from an earlier visit would
// hijack the Back scroll and jump to the wrong section.
export const clearAnchor = (key) => { if (key) anchors.delete(key); };

// History entries that should scroll to the TOP when returned to via Back/
// Forward, instead of restoring their saved pixel position. Used by pagination:
// when you click Next/Prev you've scrolled down only to reach the controls, so
// coming Back should land on the header, not the footer.
const forceTopKeys = new Set();
export const forceTopOnReturn = (key) => { if (key) forceTopKeys.add(key); };
export const shouldForceTop = (key) => (key ? forceTopKeys.has(key) : false);
